import {
  Button,
  DateRangePicker,
  FAIcon,
  MonthPicker,
  Select,
  Toggle,
} from '@/components_deprecated'
import { Field, Form, Section } from '@/modules/companies'
import { useExportOptions } from '@/modules/exports/hooks'
import { handleDateRangeChange } from '@/utils/date/handleDateRangeChange'
import { ComponentSwitch } from '@ur-solutions/react-components'
import { useTranslate } from '@ur-solutions/react-hooks'
import React, { useMemo } from 'react'
import { isMobile } from 'react-device-detect'
import { useExportDriverGradesForm } from '../../hooks'

export const ExportDriverGradesCard: React.FC = () => {
  const translations = useTranslate({
    title: 'driver-grades.export-driver-grades',
    period: 'common.period',
    exportOption: 'common.export-type',
    source: 'common.source',
    allSources: 'common.all',
    sortBy: 'common.sort-by',
    sortName: 'common.name',
    sortAvgDesc: 'driver-grades.sort-avg-desc',
    export: 'common.export',
  })

  const { loading, form, submit, updateForm, handleExport, handler } =
    useExportDriverGradesForm()

  const exportOptions = useExportOptions()

  const sourceOptions = useMemo(
    () => [
      { label: translations.allSources, value: '' as const },
      { label: 'Volvo', value: 'VOLVO' as const },
      { label: 'Scania', value: 'SCANIA' as const },
    ],
    [translations.allSources]
  )

  const sourceValue = form.sources[0] ?? ''

  const sortOptions = useMemo(
    () => [
      { label: translations.sortName, value: 'NAME' as const },
      { label: translations.sortAvgDesc, value: 'AVG_DESC' as const },
    ],
    [translations.sortName, translations.sortAvgDesc]
  )

  return (
    <Section
      header={translations.title}
      loading={loading}
      actions={
        <Toggle
          value={form.useDateRange}
          thumbBackground="secondary"
          iconMode="svg"
          localOnIconProps={{
            icon: 'calendar-selection',
            fill: form.useDateRange ? 'white' : 'primary',
          }}
          localOffIconProps={{
            icon: 'calendar-month',
            fill: !form.useDateRange ? 'white' : 'primary',
          }}
          onChange={() => handler('useDateRange')(!form.useDateRange)}
        />
      }
    >
      <Form
        grid={{
          columns: !isMobile ? '1fr 1fr 1fr' : '1fr',
          areas: !isMobile
            ? `
              'period period period'
              'exportOption source sortBy'
              'button button button'
            `
            : `
              'period'
              'exportOption'
              'source'
              'sortBy'
              'button'
            `,
        }}
      >
        <Field area="period">
          <label>{translations.period}</label>
          <ComponentSwitch>
            <ComponentSwitch.Case case={form.useDateRange}>
              <DateRangePicker
                value={[form.dateStart, form.dateEnd]}
                grayed={false}
                onChange={handleDateRangeChange(updateForm)}
              />
            </ComponentSwitch.Case>

            <ComponentSwitch.Case default>
              <MonthPicker
                value={form.month}
                light
                futureYears={0}
                noYearCycle
                onChange={handler('month')}
              />
            </ComponentSwitch.Case>
          </ComponentSwitch>
        </Field>

        <Field area="exportOption">
          <label>{translations.exportOption}</label>
          <Select
            value={form.exportOption}
            options={exportOptions}
            fullWidth
            height="3.875rem"
            onChange={handler('exportOption')}
          />
        </Field>

        <Field area="source">
          <label>{translations.source}</label>
          <Select
            value={sourceValue}
            options={sourceOptions}
            fullWidth
            height="3.875rem"
            onChange={value =>
              updateForm({
                sources: value ? [value] : [],
              })
            }
          />
        </Field>

        <Field area="sortBy">
          <label>{translations.sortBy}</label>
          <Select
            value={form.sortBy}
            options={sortOptions}
            fullWidth
            height="3.875rem"
            onChange={value => updateForm({ sortBy: value ?? undefined })}
          />
        </Field>

        <Field alignRight className="submit" area="button">
          <Button
            type="submit"
            onClick={submit(handleExport)}
            disabled={loading}
          >
            <FAIcon
              icon="download"
              type="light"
              $color="primary"
              margin="0 0.5ch 0 0"
            />
            {translations.export}
          </Button>
        </Field>
      </Form>
    </Section>
  )
}
